var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
import { asNumber } from "@/lib/number-utils";
import { ENDPOINTS } from "./config";
import { FORMULAS } from "@/lib/formulas";
function fixAPIRow(row) {
    return Object.assign(Object.assign({}, row), { personal_imports: {
            maximo_teorico: asNumber(row.personal_imports.maximo_teorico),
            concepto_fijo: asNumber(row.personal_imports.concepto_fijo),
            porcentaje_coeficiente: asNumber(row.personal_imports.porcentaje_coeficiente),
        }, volumen: {
            mes_year_actual: asNumber(row.volumen.mes_year_actual),
            mes_year_anterior: asNumber(row.volumen.mes_year_anterior),
            objetivo: asNumber(row.volumen.objetivo) / 100,
        }, volumen_acumulado: {
            acumulado_year_actual: asNumber(row.volumen_acumulado.acumulado_year_actual),
            acumulado_year_anterior: asNumber(row.volumen_acumulado.acumulado_year_anterior),
            objetivo: asNumber(row.volumen_acumulado.objetivo) / 100,
        }, clientes: {
            clientes_mes_actual: asNumber(row.clientes.clientes_mes_actual),
            clientes_mes_anterior: asNumber(row.clientes.clientes_mes_anterior),
        }, ref_promedio: {
            ref_mes_year_actual: asNumber(row.ref_promedio.ref_mes_year_actual),
            ref_mes_year_anterior: asNumber(row.ref_promedio.ref_mes_year_anterior),
        } });
}
function buildReportRow(row, weights) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const volumen = FORMULAS.volumen({
        periodo_actual: row.volumen.mes_year_actual,
        periodo_anterior: row.volumen.mes_year_anterior,
        objetivo_porcentaje: row.volumen.objetivo,
    });
    const volumen_acumulado = FORMULAS.volumen_acumulado({
        periodo_actual: row.volumen_acumulado.acumulado_year_actual,
        periodo_anterior: row.volumen_acumulado.acumulado_year_anterior,
        objetivo_porcentaje: row.volumen_acumulado.objetivo,
    });
    const clientes = FORMULAS.clientes({
        periodo_actual: row.clientes.clientes_mes_actual,
        periodo_anterior: row.clientes.clientes_mes_anterior,
    });
    const ref_promedio = FORMULAS.ref_promedio({
        periodo_actual: row.ref_promedio.ref_mes_year_actual,
        periodo_anterior: row.ref_promedio.ref_mes_year_anterior,
    });
    const computeGDAField = (obj, rtdo) => {
        if (obj <= 0)
            return null;
        return { objetivo: obj, resultado: rtdo };
    };
    const computeGDA = (gdas) => {
        return Object.fromEntries(Object.entries(gdas).map(([key, gda]) => [key, computeGDAField(gda.objetivo, gda.resultado)]));
    };
    const gda = computeGDA({
        ho_f1: { objetivo: row.GDA.Grupo1.obj_ho_f1, resultado: row.GDA.Grupo1.rtdo_ho_f1 },
        ho_f2: { objetivo: row.GDA.Grupo2.obj_ho_f2, resultado: row.GDA.Grupo2.rtdo_ho_f2 },
        ho_f3: { objetivo: row.GDA.Grupo3.obj_ho_f3, resultado: row.GDA.Grupo3.rtdo_ho_f3 },
        al_f1: { objetivo: row.GDA.Grupo4.obj_al_f1, resultado: row.GDA.Grupo4.rtdo_al_f1 },
        al_f2: { objetivo: row.GDA.Grupo5.obj_al_f2, resultado: row.GDA.Grupo5.rtdo_al_f2 },
        al_f3: { objetivo: row.GDA.Grupo6.obj_al_f3, resultado: row.GDA.Grupo6.rtdo_al_f3 },
    });
    const total_volumen = FORMULAS.total(volumen.porcentaje_conseguido);
    const total_volumen_acumulado = FORMULAS.total(volumen_acumulado.porcentaje_conseguido);
    const objetivos_mes_actual = {
        volumen: volumen.periodo_anterior + volumen.periodo_anterior * volumen.objetivo_porcentaje,
        volumen_acumulado: volumen_acumulado.periodo_anterior + volumen_acumulado.periodo_anterior * volumen_acumulado.objetivo_porcentaje,
        clientes: clientes.periodo_anterior + (clientes.periodo_anterior * 0.01),
        ref_promedio: ref_promedio.periodo_anterior,
        ho_f1: (_a = gda.ho_f1) === null || _a === void 0 ? void 0 : _a.objetivo,
        ho_f2: (_b = gda.ho_f2) === null || _b === void 0 ? void 0 : _b.objetivo,
        ho_f3: (_c = gda.ho_f3) === null || _c === void 0 ? void 0 : _c.objetivo,
        al_f1: (_d = gda.al_f1) === null || _d === void 0 ? void 0 : _d.objetivo,
        al_f2: (_e = gda.al_f2) === null || _e === void 0 ? void 0 : _e.objetivo,
        al_f3: (_f = gda.al_f3) === null || _f === void 0 ? void 0 : _f.objetivo,
    };
    const resultados_mes_actual = {
        volumen: volumen.periodo_actual,
        volumen_acumulado: volumen_acumulado.periodo_actual,
        clientes: clientes.periodo_actual,
        ref_promedio: ref_promedio.periodo_actual,
        ho_f1: (_g = gda.ho_f1) === null || _g === void 0 ? void 0 : _g.resultado,
        ho_f2: (_h = gda.ho_f2) === null || _h === void 0 ? void 0 : _h.resultado,
        ho_f3: (_j = gda.ho_f3) === null || _j === void 0 ? void 0 : _j.resultado,
        al_f1: (_k = gda.al_f1) === null || _k === void 0 ? void 0 : _k.resultado,
        al_f2: (_l = gda.al_f2) === null || _l === void 0 ? void 0 : _l.resultado,
        al_f3: (_m = gda.al_f3) === null || _m === void 0 ? void 0 : _m.resultado,
    };
    const porcentaje_cumplimiento = {
        volumen: FORMULAS.total(volumen.porcentaje_conseguido),
        volumen_acumulado: FORMULAS.total(volumen_acumulado.porcentaje_conseguido),
        clientes: FORMULAS.porcentaje_cumplimiento_clientes(clientes.objetivo, clientes.periodo_actual),
        ref_promedio: FORMULAS.total(ref_promedio.porcentaje_conseguido),
        ho_f1: gda.ho_f1 && FORMULAS.gda_compliance(gda.ho_f1.objetivo, gda.ho_f1.resultado),
        ho_f2: gda.ho_f2 && FORMULAS.gda_compliance(gda.ho_f2.objetivo, gda.ho_f2.resultado),
        ho_f3: gda.ho_f3 && FORMULAS.gda_compliance(gda.ho_f3.objetivo, gda.ho_f3.resultado),
        al_f1: gda.al_f1 && FORMULAS.gda_compliance(gda.al_f1.objetivo, gda.al_f1.resultado),
        al_f2: gda.al_f2 && FORMULAS.gda_compliance(gda.al_f2.objetivo, gda.al_f2.resultado),
        al_f3: gda.al_f3 && FORMULAS.gda_compliance(gda.al_f3.objetivo, gda.al_f3.resultado),
    };
    const { maximo_teorico, concepto_fijo, porcentaje_coeficiente } = row.personal_imports;
    const numberOfUsedGDAFields = ["ho_f1", "ho_f2", "ho_f3", "al_f1", "al_f2", "al_f3"].filter((key) => objetivos_mes_actual[key] > 0).length;
    const gdaColumnWeight = weights.GDA / numberOfUsedGDAFields;
    const importes = {
        volumen: weights.volumen * porcentaje_cumplimiento.volumen * maximo_teorico,
        volumen_acumulado: weights.volumen_acumulado * porcentaje_cumplimiento.volumen_acumulado * maximo_teorico,
        clientes: weights.clientes * porcentaje_cumplimiento.clientes * maximo_teorico,
        ref_promedio: weights.ref_promedio * porcentaje_cumplimiento.ref_promedio * maximo_teorico,
        ho_f1: gda.ho_f1 && gdaColumnWeight * porcentaje_cumplimiento.ho_f1 * maximo_teorico,
        ho_f2: gda.ho_f2 && gdaColumnWeight * porcentaje_cumplimiento.ho_f2 * maximo_teorico,
        ho_f3: gda.ho_f3 && gdaColumnWeight * porcentaje_cumplimiento.ho_f3 * maximo_teorico,
        al_f1: gda.al_f1 && gdaColumnWeight * porcentaje_cumplimiento.al_f1 * maximo_teorico,
        al_f2: gda.al_f2 && gdaColumnWeight * porcentaje_cumplimiento.al_f2 * maximo_teorico,
        al_f3: gda.al_f3 && gdaColumnWeight * porcentaje_cumplimiento.al_f3 * maximo_teorico,
    };
    const total_a_cobrar = Object.values(importes).reduce((sum, val) => sum + val, 0);
    const concepto_variable = total_a_cobrar;
    const totals = {
        total_a_cobrar,
        maximo_teorico,
        porcentaje_cumplimiento: total_a_cobrar / maximo_teorico,
        concepto_fijo,
        concepto_variable,
        porcentaje_coeficiente,
        resultado_total: (concepto_fijo + concepto_variable) * porcentaje_coeficiente,
    };
    return {
        delegacion_zona_de_ventas: row.delegacion_zona_de_ventas,
        distribuidor: row.distribuidor,
        volumen,
        volumen_acumulado,
        clientes,
        ref_promedio,
        total_volumen,
        total_volumen_acumulado,
        objetivos_mes_actual,
        resultados_mes_actual,
        porcentaje_cumplimiento,
        importes,
        totals,
    };
}
export function fetchReportData(period) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield HttpClient.get(ENDPOINTS.FETCH_REPORT_DATA, {
            ano_natural: period.year,
            mes_natural: period.month,
        }).then((rows) => ({
            weights: {
                volumen: 0.2,
                volumen_acumulado: 0.1,
                clientes: 0.15,
                ref_promedio: 0.1,
                GDA: 0.45,
            },
            data: rows.map(fixAPIRow),
        }));
        const { data, weights } = response;
        return data.map((row) => buildReportRow(row, weights));
    });
}
